import api from '../utils/api';

export const getAllEmployeeDepartment = () => {
    return api({
        url: '/api/group/getAllEmployeeDepartment',
        method: 'GET'
    })
}